import { inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CustomCookieService {

  private cookieService = inject(CookieService);
  private doc = inject(DOCUMENT);

  set(key: string, value: string): void {
    let domain = this.doc.location.hostname;
    if (domain.includes('onesecondexchange')) {
      const domainSplit = domain.split('.');
      if (domainSplit.length > 2) {
        domain = domainSplit.slice(-2).join('.');
      }
    }
    this.cookieService.set(key, value, undefined, '/', `.${domain}`);
  }

  get(name: string): string {
    return this.cookieService.get(name);
  }
}
